export default __webpack_public_path__ + "static/media/fleet_list.ca338de6.svg";